'use strict';

var AdvancedHepGridAddRowButtonController = function AdvancedHepGridAddRowButtonController($scope, advancedHepSystemConfigButtonsUtilsService, systemConfigButtonsUtilsService) {
  var gridPanel = $scope.gridPanelScope;
  $scope.isGridEditable = gridPanel.jqxGridSettings.editable;
  $scope.isAddRowButtonShown = $scope.isGridEditable && !$scope.isDefaultLevel;
  $scope.generateDataForNewRow = function () {
    var data = {};
    data.isNewlyAdded = true;
    data.hepType = $scope.selected.type;
    if ($scope.selected && $scope.selected.type && $scope.selected.type === 'FORBDLevelFareThreshold') {
      data.override = 'TRUE';
    }
    return data;
  };
  $scope.addRow = function () {
    systemConfigButtonsUtilsService.addRowToGrid($scope.generateDataForNewRow(), gridPanel, $scope.customAddNew);
    advancedHepSystemConfigButtonsUtilsService.refreshGrid(gridPanel);
  };
};
AdvancedHepGridAddRowButtonController.$inject = ['$scope', 'AdvancedHepSystemConfigButtonsUtilsService', 'SystemConfigButtonsUtilsService'];
module.exports = AdvancedHepGridAddRowButtonController;